import { useReveal } from '../lib/anim/useReveal';

const WEDGE_COPY =
  'Every other platform sells either no-code or an AI chat. Clarity rents you six proven engines + the chassis + an AI-CTO trained on twelve years of building, killing, and rescuing $1M–$50M businesses. The full operating apparatus. We ship our own six on it. You ship yours on it too.';

export function Wedge() {
  const reveal = useReveal();
  const attr = useReveal({ delay: 1 });

  return (
    <section
      className="py-32"
      style={{ background: 'var(--color-moment-bg)' }}
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div ref={reveal.ref} {...reveal.props} className={reveal.props.className}>
          {/* Indigo pull-quote glyph */}
          <span
            aria-hidden
            className="block leading-none mb-6 select-none"
            style={{
              color: 'var(--color-accent)',
              fontFamily: 'var(--font-display)',
              fontSize: '96px',
              fontWeight: 800,
              lineHeight: 0.7,
              display: 'block',
            }}
          >
            &ldquo;
          </span>
          <blockquote
            className="text-xl md:text-2xl leading-snug font-semibold"
            style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--color-moment-ink)',
              letterSpacing: '-0.01em',
              lineHeight: 1.38,
            }}
          >
            {WEDGE_COPY}
          </blockquote>
        </div>
        <div ref={attr.ref} {...attr.props} className={`mt-8 ${attr.props.className}`}>
          <p
            className="text-xs uppercase tracking-[0.16em]"
            style={{ color: 'rgba(232, 234, 242, 0.5)', fontFamily: 'var(--font-mono)' }}
          >
            — Ryan Richardson · Onwards Analytics
          </p>
        </div>
      </div>
    </section>
  );
}
